import { Tooltip } from "@xola/ui-kit";
import { DateFormat, DemographicIcon, formatDate } from "common";
import React from "react";
import { Waiver, WaiverParticipant } from "types";
import { useIsParticipantMinor } from "../../../models/Waiver";
import { NoTranslate } from "../../Common/NoTranslate";

export const WaiverParticipantDetails = ({
    waiver,
    size,
    nameMaxLength,
}: {
    waiver: Waiver;
    size?: string;
    nameMaxLength?: number;
}) => {
    return (
        <div>
            {waiver.participants?.map((participant) => (
                <ParticipantDetails
                    key={participant.id}
                    participant={participant}
                    waiverTypeId={waiver.waiverTypeId}
                    size={size}
                    nameMaxLength={nameMaxLength}
                />
            ))}
        </div>
    );
};

export const ParticipantDetails = ({
    participant,
    waiverTypeId,
    size,
    nameMaxLength,
}: {
    participant: WaiverParticipant;
    waiverTypeId: ID;
    size?: string;
    nameMaxLength?: number;
}) => {
    const isMinor = useIsParticipantMinor(participant, waiverTypeId);

    const isCustomerNameLengthExceedingMax = nameMaxLength ? participant.customerName.length > nameMaxLength : false;

    return (
        <Tooltip
            content={
                isMinor
                    ? `${
                          isCustomerNameLengthExceedingMax ? participant.customerName + " " : ""
                      }Minor, DOB: ${formatDate(participant.dateOfBirth, DateFormat.DATE)}`
                    : participant.customerName
            }
            disabled={!isCustomerNameLengthExceedingMax && !isMinor}
        >
            <div className="flex items-center space-y-0.5">
                <DemographicIcon name={isMinor ? "child" : "adult"} size={size} className="mt-0.5" />
                <NoTranslate className="ml-1">
                    {isCustomerNameLengthExceedingMax
                        ? participant.customerName.slice(0, nameMaxLength)
                        : participant.customerName}{" "}
                    {isCustomerNameLengthExceedingMax && "..."}
                </NoTranslate>
            </div>
        </Tooltip>
    );
};
